import { ContractAddresses } from '../ContractAddresses'

export class XyoNetworkWrapper {
  public addresses: ContractAddresses

  public chainId: number

  constructor(chainId: number) {
    this.chainId = chainId
    this.addresses = {}
  }
}
